export const fallbackConvexUrl = "https://haulbase-placeholder.convex.cloud";

export function resolveConvexClientUrl(value: string | undefined): {
  url: string;
  configured: boolean;
} {
  return {
    url: value || fallbackConvexUrl,
    configured: Boolean(value),
  };
}
